import React, { useEffect, useRef } from 'react'
import ArticleField from '../ArticleField';
import { TextField } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

interface UrlTitleProps {
    value: string,
    onChange: (value: string) => void,
    type: "create" | "edit",
}

function useFirstValue(value: string) {
    const ref = useRef("");

    useEffect(() => {
        if (ref.current === "") {
            ref.current = value;
        }
    }, [value]);
    return ref.current;
}

const UrlTitle = (props: UrlTitleProps) => {
    const first = useFirstValue(props.value);

    return <ArticleField>
        <TextField
            disabled={props.type === "edit" ? true : false}
            inputProps={{ maxLength: 240 }}
            fullWidth={true}
            label="Url Title"
            value={props.value}
            onChange={(e) => {
                props.onChange(e.target.value);
            }} />
        <span>{props.value.length}/240</span>
        { props.type === "edit" && first !== props.value &&
            <Alert severity="warning">Attention changer le slug d'un article peut avoir un impact négatif sur le référencement</Alert>
        }
    </ArticleField>
}


export default UrlTitle;